module.exports = __webpack_public_path__ + "ac41117a591b3f629dc023d2177a800e.jpg";